export default __webpack_public_path__ + "static/media/1.e1ba4f87.png";